import React from 'react';

export interface Sort {
    id: string;
    desc: boolean;
}

const useSorting = (defaultSort: Sort | null = null): {
    sort: Sort | null;
    setSort: (sort: Sort) => void;
    removeSort: () => void;
    toggleSort: (id: string, desc: boolean) => void;
} => {
    const [sort, setSortState] = React.useState<Sort | null>(defaultSort);
    const toggleSort = (id: string, desc: boolean): void => {
        setSortState({ id, desc });
    };
    const setSort = (sortParam: Sort): void => {
        setSortState(sortParam);
    };
    const removeSort = (): void => setSortState(null);

    return {
        removeSort,
        setSort,
        sort,
        toggleSort,
    };
};

export default useSorting;
